import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import '../styles/CampaignPopup.css';
import api from '../config/api';

const CampaignPopup = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [campaignData, setCampaignData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [shouldShow, setShouldShow] = useState(true);
    const location = useLocation();

    // Sadece Home sayfasında çalışsın
    const isHomePage = location.pathname === '/';

    // İlk yüklemede popup'ın gösterilip gösterilmeyeceğini kontrol et
    useEffect(() => {
        if (!isHomePage) return;

        const checkShouldShow = () => {
            const lastClosed = localStorage.getItem('campaignPopupClosed');
            
            if (!lastClosed) {
                console.log('Popup daha önce kapatılmamış, gösterilebilir');
                setShouldShow(true);
                return;
            }

            try {
                const closedTime = new Date(lastClosed);
                const now = new Date();
                
                console.log('Popup kontrol:', {
                    lastClosed,
                    closedTime: closedTime.getTime(),
                    now: now.getTime(),
                    diff: now.getTime() - closedTime.getTime(),
                    shouldShow: now.getTime() > closedTime.getTime()
                });
                
                if (now.getTime() > closedTime.getTime()) {
                    console.log('Popup süresi dolmuş, gösterilebilir');
                    localStorage.removeItem('campaignPopupClosed');
                    setShouldShow(true);
                } else {
                    console.log('Popup hala gizli kalmalı');
                    setShouldShow(false);
                }
            } catch (error) {
                console.error('Tarih parse hatası:', error);
                localStorage.removeItem('campaignPopupClosed');
                setShouldShow(true);
            }
        };

        checkShouldShow();
    }, [isHomePage]);

    useEffect(() => {
        // Sadece Home sayfasında ve gösterilmesi gerekiyorsa API çağrısı yap
        if (!isHomePage || !shouldShow) {
            setIsLoading(false);
            return;
        }

        fetchCampaignData();
    }, [isHomePage, shouldShow]);

    useEffect(() => {
        // Kampanya verisi geldi ve gösterilmesi gerekiyorsa timer başlat
        if (!isHomePage || !shouldShow || !campaignData?.hasCampaign) {
            return;
        }

        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 2000);

        return () => clearTimeout(timer);
    }, [campaignData, isHomePage, shouldShow]);

    const fetchCampaignData = async () => {
        try {
            console.log('Kampanya bilgisi alınıyor...');
            const response = await api.get('/parameters/campaign/current');
            console.log('API Response:', response.data);
            
            if (response.data.success) {
                setCampaignData(response.data.data);
            } else {
                console.log('Kampanya bulunamadı veya aktif değil');
                setCampaignData({ hasCampaign: false });
            }
        } catch (error) {
            console.error('Kampanya bilgisi alınamadı:', error);
            setCampaignData({ hasCampaign: false });
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        setIsVisible(false);
        setShouldShow(false);
        
        // 24 saat sonrasının timestamp'ini kaydet
        const now = new Date();
        const tomorrow = new Date(now.getTime() + 24 * 60 * 60 * 1000);
        
        localStorage.setItem('campaignPopupClosed', tomorrow.toISOString());
        
        console.log('Popup kapatıldı:', {
            now: now.toISOString(),
            closedUntil: tomorrow.toISOString(),
            timestamp: tomorrow.getTime()
        });
    };

    const handleShopNow = () => {
        window.location.href = '/products';
        setIsVisible(false);
    };

    // Debug için console log
    useEffect(() => {
        console.log('CampaignPopup State:', {
            isHomePage,
            shouldShow,
            isLoading,
            campaignData: campaignData?.hasCampaign,
            isVisible
        });
    }, [isHomePage, shouldShow, isLoading, campaignData, isVisible]);

    // Home sayfasında değilse veya gösterilmemesi gerekiyorsa
    if (!isHomePage || !shouldShow) {
        return null;
    }

    if (isLoading) {
        return null;
    }

    if (!campaignData?.hasCampaign || !isVisible) {
        return null;
    }

    // Metni satırlara böl ve formatla
    const formatMessage = (message) => {
        if (!message) return [];
        
        let processedMessage = message;
        
        if (typeof processedMessage === 'string') {
            processedMessage = processedMessage.replace(/\\n/g, '\n');
        }
        
        const lines = processedMessage.split('\n');
        
        return lines
            .filter(line => line.trim() !== '')
            .map((line, index) => {
                if (line.startsWith('•')) {
                    return (
                        <p key={index} className="campaign-bullet">
                            {line}
                        </p>
                    );
                } else {
                    return (
                        <p key={index} className="campaign-text">
                            {line}
                        </p>
                    );
                }
            });
    };

    return (
        <div className="campaign-popup-overlay">
            <div className="campaign-popup">
                <button className="campaign-popup-close" onClick={handleClose}>
                    <X size={24} />
                </button>
                
                <div className="campaign-popup-content">
                    <div className="campaign-icon">
                        🎉
                    </div>
                    
                    <h2 className="campaign-title">
                        Özel Kampanya!
                    </h2>
                    
                    <div className="campaign-message">
                        {formatMessage(campaignData.message)}
                    </div>
                    
                    <div className="campaign-actions">
                        <button className="btn-shop-now" onClick={handleShopNow}>
                            Hemen Alışverişe Başla!
                        </button>
                        
                        <button className="btn-close" onClick={handleClose}>
                            Daha Sonra
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CampaignPopup;
